export const LANGS = {
    RU: 'RU',
    EN: 'EN',
    UK: 'UK',
    TR: 'TR',
} as const

export type TypeLanguages = typeof LANGS

export type LangType = keyof TypeLanguages

export type TranslatesType = Record<LangType, MessagesType>

export type MessagesType = {
  [key: string]: string;
}
